import { hist } from 'index';
import React from 'react';
import ReactBSAlert from 'react-bootstrap-sweetalert';
import Loader from 'react-loader-spinner';
import { Route } from 'react-router-dom';
import { Button, ButtonGroup, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

/**
 * 
 * @param {*} pParent 
 * @param {*} pField 
 * @param {*} pData 
 * @param {*} pFielDataEdit 
 * @param {*} pAction 
 * @param {*} pReferent 
 */
export const FrameWorkPutValueIfEditByDefault = (pParent, pField, pData, pFielDataEdit, pAction, pReferent) => {
  if (pData == null) {
    return;
  }
  if (pData[pFielDataEdit] !== null && pData[pFielDataEdit] !== undefined) {
    pParent.setState({ [pField]: pData[pFielDataEdit] });
    FrameWorkChange(pParent, pData[pFielDataEdit], pField, pAction, pReferent);
  }
}
/**
 * Permite controlar los cambios sobre un campo en un formulario,
 * con ello se busca poder mostrar los campos obligatorios y a
 * cada uno que falte señalarlo con un etiqueta de control
 * @param {*} pParent 
 * @param {*} localValue 
 * @param {*} stateName 
 * @param {*} type 
 * @param {*} stateNameEqualTo 
 * @param {*} maxValue 
 */
export const FrameWorkChange = (pParent, localValue, stateName, type, stateNameEqualTo, maxValue) => {
  var isCorrect = true;
  switch (type) {
    case 'have-content':
      if (FrameWorkVerifyHaveValue(localValue, stateNameEqualTo)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'email':
      if (FrameWorkVerifyEmail(localValue)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'password':
      if (FrameWorkVerifyLength(localValue, 1)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'equalTo':
      if (FrameWorkCompare(localValue, pParent.state[stateNameEqualTo])) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
        pParent.setState({ [stateNameEqualTo + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        pParent.setState({ [stateNameEqualTo + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'number':
      if (FrameWorkVerifyNumber(localValue.value)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'length':
      if (FrameWorkVerifyLength(localValue, stateNameEqualTo)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'max-length':
      if (!FrameWorkVerifyLength(localValue, stateNameEqualTo + 1)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'url':
      if (FrameWorkVerifyUrl(localValue)) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'min-value':
      if (
        FrameWorkVerifyNumber(localValue) &&
        localValue >= stateNameEqualTo
      ) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'max-value':
      if (
        FrameWorkVerifyNumber(localValue) &&
        localValue <= stateNameEqualTo
      ) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    case 'range':
      if (
        FrameWorkVerifyNumber(localValue) &&
        localValue >= stateNameEqualTo &&
        localValue <= maxValue
      ) {
        pParent.setState({ [stateName + 'State']: 'has-success' });
      } else {
        pParent.setState({ [stateName + 'State']: 'has-danger' });
        isCorrect = false;
      }
      break;
    default:
      break;
  }
  pParent.setState({ [stateName]: localValue });
  return isCorrect;
};
/**
 * Esta función recibe un valor a probar y un límite de tamaño, 
 * después de limpiar dicho valor, el sistema veriifca que cumpla
 * su contenido con el número mínimo deseado
 * @param {*} pValue 
 * @param {*} pLimit 
 */
export const FrameWorkVerifyHaveValue = (pValue, pLimit) => {
  try {
    if (pValue === undefined) {
      pValue = '';
    }
    var localData = pValue + '';
    localData = localData.trim();
    localData = localData.replace('   ', ' ');
    localData = localData.replace('  ', ' ');
    return localData.length >= pLimit;
  } catch (error) {
    return false;
  }
};
/**
 * Function that returns true if value is email, false otherwise
 * @param {*} value 
 */
export const FrameWorkVerifyEmail = value => {
  var emailRex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
};
/**
 * Function that verifies if a string has a given length or not
 * @param {*} value 
 * @param {*} length 
 */
export const FrameWorkVerifyLength = (value, length) => {
  if (value.length >= length) {
    return true;
  }
  return false;
};
/**
 * Function that verifies if two strings are equal
 * @param {*} string1 
 * @param {*} string2 
 */
export const FrameWorkCompare = (string1, string2) => {
  if (string1 === string2) {
    return true;
  }
  return false;
};
/**
 * Function that verifies if value contains only numbers 
 * @param {*} value 
 */
export const FrameWorkVerifyNumber = value => {
  var numberRex = new RegExp('^[0-9]+$');
  if (numberRex.test(value)) {
    return true;
  }
  return false;
};
/**
 * Verifies if value is a valid URL 
 * @param {*} value 
 */
export const FrameWorkVerifyUrl = value => {
  try {
    new URL(value);
    return true;
  } catch (_) {
    return false;
  }
};
/**
 * Verifica si un campo contiene contenido o pasó por 
 * la comprobación de etiqueta de contenido
 * @param {*} pState 
 */
export const FrameWorkVerifyDataIsCompleted = (pState) => {
  return pState === '' || pState === 'has-danger' || pState == null;
};
/**
 * Verifica un dato enviado y en caso de no existir o estar vacío 
 * pone en su lugar un valor por defecto también enviado
 * @param {*} pData 
 * @param {*} pFiel 
 */
export const FrameWorkGetDefaulValue = (pData, pFiel, pDefault = '') => {
  if (pData === null) {
    return pDefault;
  }
  if (pData === undefined) {
    return pDefault;
  }
  if (pData[pFiel] === null || pData[pFiel] === undefined) {
    return pDefault;
  }
  return pData[pFiel];
};
/**
 * Genera una ventana modal que permite al usuario decidir aceptar o cancelar una solicitud realizada
 * @param {*} pParent Padre de la solicitud puede ser this o clase de referencia que tiene la responsabilidad
 * @param {*} pTitle Título a mostrar en la ventana
 * @param {*} pMessage Mesnaje que desea mostrar al usuario
 * @param {*} pAceptProcess Función de respuesta afirmativa
 * @param {*} pCancelProcess Función de respuesta negativa
 * @param {*} pValueAcept Valor que se envía en la función de respuesta afirmativa
 * @param {*} pValueCancel valor ques e envía en la función de respuesta negativa
 * @param {*} pLabelState Etiqueta en la que se esta dibujando la ventana modal
 */
export const FrameWorkMessageAceptCancel = (pParent, pTitle, pMessage, pAceptProcess, pCancelProcess, pValueAcept, pValueCancel, pLabelState = 'alert') => {
  pParent.setState({
    [pLabelState]: (
      <ReactBSAlert
        info
        style={{ display: 'block', marginTop: '-300px' }}
        title={pTitle}
        onConfirm={() => {
          FrameWorkHideAlert(pParent, pLabelState);
          if (pAceptProcess) {
            pAceptProcess(pValueAcept);
          }
        }
        }
        onCancel={() => {
          FrameWorkHideAlert(pParent, pLabelState);
          if (pCancelProcess) {
            pCancelProcess(pValueCancel);
          }
        }
        }
        confirmBtnBsStyle={FrameWorkGetPrimaryColorButton()}
        cancelBtnBsStyle={'default'}
        confirmBtnText='Aceptar'
        cancelBtnText='Cancelar'
        showConfirm={true}
        showCancel={true}
      >
        {pMessage}
      </ReactBSAlert>
    )
  });
};
/**
 * Genera un mensaje modal visualizado en la etiqueta
 * solicitada sino por defecto lo hace en la etiqueta alert
 * @param {*} pParent 
 * @param {*} pTitle 
 * @param {*} pMessage 
 * @param {*} pLabelState 
 */
export const FrameWorkMessageErrorAlert = (pParent, pTitle, pMessage, pLabelState = 'alert', pCallBack = () => { return }) => {
  pParent.setState({
    [pLabelState]: (
      <ReactBSAlert
        danger
        style={{ display: 'block', marginTop: '-200px' }}
        title={pTitle}
        onConfirm={() => {
          FrameWorkHideAlert(pParent);
          pCallBack();
        }
        }
        onCancel={() => {
          FrameWorkHideAlert(pParent);
          pCallBack();
        }
        }
        confirmBtnBsStyle={FrameWorkGetPrimaryColorButton()}
        cancelBtnBsStyle={FrameWorkGetPrimaryColorButton()}
        confirmBtnText='Aceptar'
      >
        {pMessage}
      </ReactBSAlert>
    )
  });
};
/**
 * Genera un mensaje modal que muestra el estado de éxito de una operación
 * esta se muesta en la etiqueta del estado enviada o por defecto en alert
 * @param {*} pParent 
 * @param {*} pTitle 
 * @param {*} pMessage 
 * @param {*} pLabelState 
 */
export const FrameWorkMessageSuccessAlert = (
  pParent,
  pTitle,
  pMessage,
  pProcessCallBackAcept = () => { return },
  pProcessCallBackCancel = () => { return },
  pLabelState = 'alert', ) => {
  pParent.setState({
    [pLabelState]: (
      <ReactBSAlert
        success
        style={{ display: 'block', marginTop: '-200px' }}
        title={pTitle}
        confirmBtnBsStyle={FrameWorkGetPrimaryColorButton()}
        cancelBtnBsStyle={FrameWorkGetPrimaryColorButton()}
        onConfirm={() => {
          FrameWorkHideAlert(pParent);
          pProcessCallBackAcept();
        }}
        onCancel={() => {
          FrameWorkHideAlert(pParent);
          pProcessCallBackCancel();
        }}
        confirmBtnText='Aceptar'
      >
        {pMessage}
      </ReactBSAlert>
    )
  });
};
/**
 * Genera un mensaje modal de estado procesando, el cual solo se puede cancelar por código y
 * no por la intervención del usuario se visualiza en la etiqueta del estado enviada o por
 * defecto en la etiqueta alert
 * @param {*} pParent 
 * @param {*} pTitle 
 * @param {*} pMessage 
 * @param {*} pLabelState 
 */
export const FrameWorkSimpleMessageState = (pParent, pTitle, pMessage, pLabelState = 'alert') => {
  pParent.setState({
    [pLabelState]: (
      <ReactBSAlert
        custom
        style={{ display: 'block', marginTop: '-200px' }}
        title={pTitle}
        customIcon={
          <Loader
            type='Oval'
            color='#51cbce'
            height='100'
            width='100'
          />
        }
        onConfirm={() => FrameWorkHideAlert(pParent)}
        showConfirm={false}
        confirmBtnBsStyle={FrameWorkGetPrimaryColorButton()}
        cancelBtnBsStyle={FrameWorkGetPrimaryColorButton()}
      >
        {pMessage}
      </ReactBSAlert>
    )
  });
};
/**
 * Desactiva la etiqueta colocando su contenido en null
 * @param {*} pParent elemento que contiene acceso a la etiqueta solicitda
 * @param {*} pLabel valor por defecto alert
 */
export const FrameWorkHideAlert = (pParent, pLabel = 'alert') => {
  pParent.setState({
    [pLabel]: null
  });
};
/**
 * Retorna dado el valor de estado actual y el valor por defecto
 * el correspondiente texto de activo o inactivo 
 * @param {*} stateActiveUser 
 * @param {*} stateInicialActiveUser 
 */
export const FrameWorkPutTextToActiveInactiveUser = (stateActiveUser, stateInicialActiveUser) => {
  return FrameWorkPutTextToCheck(stateActiveUser, stateInicialActiveUser, 'Activo', 'Inactivo');
}
/**
 * Retorna el valor según el estdo actual para un texto en los check
 * @param {*} pStateCheck 
 * @param {*} startState 
 * @param {*} pLabelActive 
 * @param {*} plabelInactive 
 */
export const FrameWorkPutTextToCheck = (pStateCheck, startState, pLabelActive, plabelInactive) => {
  var localState = pStateCheck;
  if (pStateCheck === null || pStateCheck === undefined) {
    localState = startState;
  }
  if (localState === 1 || localState === true) {
    return pLabelActive;
  }
  return plabelInactive;
}
/**
 * Dado un elemento y un campo de dicho elemento, el cual se espera sea un vector
 * retorna un vector vacío en caso que estos datos no procesen o el vector del campo
 * esto para evitar en tiempo de ejecución errores.
 * @param {*} pData 
 * @param {*} pField 
 */
export const FrameWorkGetMapFromItem = (pData, pField) => {
  if (pData === null) {
    return [];
  }
  if (pData === undefined) {
    return [];
  }
  if (pData[pField] === null) {
    return [];
  }
  if (pData[pField] === undefined) {
    return [];
  }
  return pData[pField];
}
/**
 * Creado para colocar en un solo punto los colores de uso de botones
 * cuando estos son los primeros en importancia
 */
export const FrameWorkGetPrimaryColorButton = () => {
  return 'warning';
}
/**
 * Creado para colocar en un solo punto los colores de uso de botones
 * cuanando estos son los segundos en importancia
 */
export const FrameWorkGetSecundaryColorButton = () => {
  return 'secundary';
}
/**
 * Estructura que denota la estructura de respusta que se usa en el sistema
 * de esta manera se reconocen las operaciones remotas y sus respectivos resultados
 * @param {*} errorState 
 * @param {*} message 
 * @param {*} systemMessage 
 * @param {*} result 
 */
export const ANSWER_MESSAGE = (errorState = false, message = '', systemMessage = '', result = [], filterNavegation = null) => {
  return {
    errorState,
    message,
    systemMessage,
    result,
    filterNavegation,
  }
};
/**
 * Genera la estructura de consulta que se debe enviar al servidor,
 * para que permita hacer la paginación
 * @param {*} action 0 inicial 1 siguiente 2 anterior 3 refrescar
 * @param {*} limit 
 * @param {*} offset 
 * @param {*} filtert1 
 * @param {*} filtert2 
 * @param {*} filtert3 
 * @param {*} filtert4 
 * @param {*} filtert5 
 */
export const REQUEST_NAVIGATION_STRUCTURE = (action = 0, limit = 20, offset = 0, moveToPage = 1, filter1 = '', filter2 = '', filter3 = '', filter4 = '', filter5 = '') => {
  return {
    action,
    limit,
    offset,
    moveToPage,
    filter1,
    filter2,
    filter3,
    filter4,
    filter5,
  }
};
/**
 * Dado un valor de fecha timstamp se retona este en el formato YYYY/MM/dd
 * @param {*} pData TimeStamp on el valor de la fecha
 */
export const FrameWorkFormatDate = (pData, pSeparator = '/') => {
  var date = pData;
  if (Object.prototype.toString.call(pData) !== '[object Date]') {
    date = new Date(pData);
  }
  if (isNaN(date)) {
    return '';
  }
  var result = '';
  var year = date.getFullYear();
  var month = (date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month;
  }
  if (day < 10) {
    day = '0' + day;
  }
  result = +
    year + pSeparator + month + pSeparator + day;
  return result;
}

export const FrameWorkModifiedValue = (pVectorJSON, pLabelElement, pValue, pLabelField) => {
  if (pVectorJSON[pLabelElement]) {

  }
}

export const FrameWorkOrderVector = (pVector, pLabel) => {
  var resultVector = pVector.sort((a, b) => {
    if (a[pLabel] < b[pLabel])
      return -1;
    if (a[pLabel] > b[pLabel])
      return 1;
    return 0;
  });
  return resultVector;
}

export const FrameWorkModalQuantity = (pParent, pLabelStateModal, pLabelStateValue, pProduct, pRequestSuccess, pRequestCancel, pActualValue = 1) => {

  if (pActualValue <= (pProduct.quantityAvailable || 1)) {
    pActualValue = pProduct.quantityAvailable;
    pParent.setState({
      [pLabelStateValue]: pProduct.quantityAvailable
    });
  }

  pParent.setState({
    [pLabelStateValue]: pActualValue
  });

  pParent.setState({
    [pLabelStateModal]: (
      <div>
        <Modal isOpen={true} toggle={pRequestCancel}>
          <ModalHeader ><b>{pProduct.name}{' ('}</b>{pProduct.nameMeasureUnit}<b>{')'}</b></ModalHeader>
          <ModalBody>
            {/*<Row>
              <Col md='auto'>
                <Label>
                   <b>Presentación:</b>
                </Label>
              </Col>
              <Col md='auto'>
                {pProduct.nameMeasureUnit}
              </Col>
            </Row>*/}
            <Row>
              <Col md='auto'>
                <Label>
                  <b>Mínimo:</b>
                </Label>
              </Col>
              <Col md='auto' className='ml-3'>
                {pProduct.quantityAvailable}{' ('}{pProduct.nameMeasureUnit}{')'}
              </Col>
            </Row>
            <Row>
              <Col md='auto'>
                <Label>
                  <b>Cantidad:</b>
                </Label>
              </Col>
              <Col md='auto'>
                <FormGroup>
                  <Input
                    id='idLocalQuantity'
                    placeholder='Cantidad'
                    type='number'
                    defaultValue={pActualValue < pProduct.quantityAvailable ? '' : pActualValue}
                    onKeyDown={event => {
                      if (event.keyCode === 13) {
                        event.preventDefault();
                        pRequestSuccess(pProduct, pParent.state[pLabelStateValue]);
                      }
                    }}
                    onChange={(event) => {
                      if (event.target.value !== '') {
                        if (event.target.value === 0) {
                          event.target.value = 1;
                        } else if (event.target.value < 0) {
                          event.target.value = Math.abs(event.target.value);
                        }
                        pParent.setState({
                          [pLabelStateValue]: event.target.value
                        });
                      }
                    }}
                  />
                </FormGroup>
                <ButtonGroup className='btn-group-sm'>
                  <Button
                    className='btn-round'
                    color='default'
                    outline
                    onClick={event => {
                      var localDataProcess = parseInt(pParent.state[pLabelStateValue], 10) - 1
                      if (localDataProcess < 1) {
                        localDataProcess = 1;
                      }
                      document.getElementById('idLocalQuantity').value = localDataProcess
                      pParent.setState({
                        [pLabelStateValue]: localDataProcess
                      });
                    }}
                  >
                    <i className='nc-icon nc-simple-delete' />
                  </Button>
                  <Button
                    className='btn-round'
                    color='default'
                    outline
                    onClick={event => {

                      var localDataProcess = parseInt(pParent.state[pLabelStateValue], 10) + 1;
                      if (document.getElementById('idLocalQuantity').value === '') {
                        localDataProcess = 1;
                      }
                      if (localDataProcess < 1) {
                        localDataProcess = 1;
                      }
                      document.getElementById('idLocalQuantity').value = localDataProcess
                      pParent.setState({
                        [pLabelStateValue]: localDataProcess
                      });
                    }}
                  >
                    <i className='nc-icon nc-simple-add' />
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter style={{ paddingRight: 20 }}>
            <Button
              className='btn-round'
              color='default'
              onClick={() => {
                pRequestCancel();
              }
              }
            >
              Cancelar
            </Button>
            <Button
              className='btn-round'
              color='warning'
              onClick={() => {
                var dataInEditor = parseInt(document.getElementById('idLocalQuantity').value, 10);
                var localDataProcess = parseInt(pParent.state[pLabelStateValue], 10);
                //document.getElementById('idLocalQuantity').value = localDataProcess;
                if (localDataProcess >= pProduct.quantityAvailable && dataInEditor === localDataProcess) {
                  pRequestSuccess(pProduct, pParent.state[pLabelStateValue]);
                } else {
                  FrameWorkMessageErrorAlert(pParent, 'Error en cantidad', 'La cantidad mínima debe ser ' + (pProduct.quantityAvailable || 1));
                  //alert('Error: '+'La cantidad mínima debe ser '+(pProduct.quantityAvailable||1));
                }
              }
              }
            >
              Aceptar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  })
}

/*******************************************************************************************************/
/**
 * Aunque hace parte del Framework, esta es una función muy específica del caso 
 * para el manejo de navegación de productos
 * @param {*} pReferenceState 
 * @param {*} pReferenceProps 
 * @param {*} pAction 0 inicial 1 siguiente 2 anterior 3 actual
 * @param {*} pOffset fila en la que se incia la visualización de los datos
 * @param {*} pLimit número máximo de registros a trater
 */
export const OrdenExpressApplyFiltersSpecificProducts = (
  pReferenceState,
  pReferenceProps,
  pAction = 0,
  pOffset = 0,
  pPage = 1,
  pLimit = 20) => {
  var filterCategory = '%';
  var filtertext = '%';
  try {
    filterCategory = pReferenceState.filterTypeCategory.value;
    if (filterCategory.trim() === '' || filterCategory === 'Todos' || filterCategory === undefined || filterCategory === null) {
      filterCategory = '%';
    }
  } catch (error) { console.error(error) }
  try {
    if (pReferenceState.filterTextSearchProduct.trim() !== '' && pReferenceState.filterTextSearchProduct !== undefined) {
      filtertext = '%' + pReferenceState.filterTextSearchProduct.trim() + '%';
    }
  } catch (error) { console.error(error) }
  try {
    pReferenceProps.requestGetProductsFilter(
      REQUEST_NAVIGATION_STRUCTURE(
        pAction,
        pLimit,
        pOffset,
        pPage,
        filterCategory,
        filtertext,

      )
    );
  } catch (error) { console.error(error) }
}
/**
 * Retorna el producto almacenado en el vector que coincide con
 * el id enviado, en caso de no encontrarlo retona null
 * @param {*} pParent 
 * @param {*} pLabelVector 
 * @param {*} idProduct 
 */
export const OrdenExpressGetProductFromVector = (pParent, pLabelVector, pIdProduct, pLable = 'id') => {
  var response = null;
  if (pParent == null) {
    return response;
  }
  if (pParent === undefined) {
    return response;
  }
  if (pLabelVector == null) {
    return response;
  }
  if (pLabelVector === undefined) {
    return response;
  }
  var pos = 0;
  var contetProducts = pParent[pLabelVector];
  const tama = contetProducts.length;
  var isFound = false;
  while (pos < tama && !isFound) {
    if (contetProducts[pos][pLable] === pIdProduct) {
      response = contetProducts[pos];
      isFound = true;
    }
    pos++;
  }
  return response;
}
/**
 * Ingresa el elemento en el vector, en caso de que exista lo 
 * reemplaza, y sino lo agrega
 * @param {*} pParent 
 * @param {*} pLabelVector 
 * @param {*} pNewProduct 
 */
export const OrdenExpressSetProductToVector = (pParent, pLabelVector, pNewProduct) => {
  var response = null;
  if (pParent == null) {
    return response;
  }
  if (pParent === undefined) {
    return response;
  }
  if (pLabelVector == null) {
    return response;
  }
  if (pLabelVector === undefined) {
    return response;
  }
  if (pNewProduct == null) {
    return response;
  }
  if (pNewProduct === undefined) {
    return response;
  }
  response = pParent[pLabelVector];
  var pos = 0;
  var contetProducts = pParent[pLabelVector];
  const tama = contetProducts.length;
  var isFound = false;
  while (pos < tama && !isFound) {
    if (contetProducts[pos].id === pNewProduct.id) {
      contetProducts[pos] = pNewProduct;
      response = contetProducts;
      isFound = true;
    }
    pos++;
  }
  if (!isFound) {
    response.push(pNewProduct);
  }
  return response;
}
/**
 * Dado los datos del vector actual y el id del producto a retirar
 * el sistem retorna al vector si estos elementos
 * @param {*} pParent 
 * @param {*} pLabelVector 
 * @param {*} id 
 */
export const OrdenExpressRemoveProductFromVector = (pParent, pLabelVector, pIdProduct) => {
  var response = null;
  if (pParent == null) {
    return response;
  }
  if (pParent === undefined) {
    return response;
  }
  if (pLabelVector == null) {
    return response;
  }
  if (pLabelVector === undefined) {
    return response;
  }
  response = [];
  var contentVector = pParent[pLabelVector];
  var pos = 0;
  var length = contentVector.length;
  while (pos < length) {
    var localProduct = contentVector[pos];
    if (localProduct.id !== pIdProduct) {
      response.push(localProduct);
    }
    pos++;
  }
  /*pParent[pLabelVector].map((localProduct, indexProduct) => {
    if (localProduct.id != pIdProduct) {
      response.push(localProduct);
    }
  })*/
  return response;
}
/**
 * Permite navegar de forma segura entre las opciones del sistema,
 * es necesario su uso para lograr que se realicen las validaciones de 
 * permisos a la hora de ingresar a las páginas que conforman la aplicación.
 * @param {*} pParent this del componnet que usa el servicio
 * @param {*} pSimplePath ruta a la que se desea navegar
 * @param {*} pHistory objeto con el historial de la navegación
 */
export const OrdenExpressNavegatePath = (pParent, pSimplePath, pHistory) => {
  try {
    var completePath = '/client/';
    if (OrdenExpressIsAdmin(pParent)) {
      completePath = '/admin/';
    }
    if (pSimplePath.trim() === '/') {
      completePath = '';
    }
    completePath += pSimplePath;
    var toVerificate = completePath.split('?')[0].trim();
    const state = pParent.props.loginReducerState;
    const menuPermissions = state.requestMenuPermissions || [];
    var localFound = false;
    var pos = 0;
    var length = menuPermissions.length;
    while (pos < length) {
      var pPath = menuPermissions[pos];
      if (pPath === toVerificate) {
        localFound = true;
      }
      pos++;
    }
    /*menuPermissions.map((pPath) => {
      if (pPath === toVerificate) {
        localFound = true;
      }
    })*/
    if (localFound) {
      hist.push(completePath);
    }
  } catch (__) {

  }
}
/**
 * Valida que el objeto de usuario login esté disponible sin errores, 
 * en caso de que no exista o presente un error, el sistema pasa
 * de inmediato al login
 * @param {*} pParent corresponde a la referencia del comonent que hace uso de la función normalmente es el this 
 */
export const OrdenExpressValidateSecurity = (pParent, pIsAdmin = true, pHistory) => {
  var close = false;
  var localPath = '';
  if (!pHistory) pHistory = pParent.props;
  if (pHistory) localPath = pHistory.history.location.pathname;
  try {
    const state = pParent.props.loginReducerState;
    if (state.responseVerifiedUser.errorState !== false) {
      close = true;
    }
    const menuPermissions = state.requestMenuPermissions || [];
    var localFound = false;
    var pos = 0;
    var length = menuPermissions.length;
    while (pos < length) {
      var pPath = menuPermissions[pos];
      if (pPath === localPath) {
        localFound = true;
      }
      pos++;
    }
    /* menuPermissions.map((pPath, pIndex) => {
       if (pPath === localPath) {
         localFound = true;
       }
     })*/
    if (!localFound && menuPermissions.length > 0) {
      close = true;
    }
  } catch (__) {
    close = true;
  }
  if (close) {
    if (!pHistory) pHistory = pParent.props;
    if (pHistory) pHistory.history.push('/');
  }
  return close;
}
/**
 * Cierra el sistema, si un microservicio retorna dicha solicitud
 * @param {*} pAnswer 
 * @param {*} action 
 * @param {*} state 
 * @param {*} pHistory 
 */
export const OrdenExpressValidateSecurityForAnswer = (pAnswer, pHistory) => {
  try {
    if (pAnswer) {
      if (pAnswer['exitOfSystem'] === true) {
        hist.push('/');
      }
    }
  } catch (__) { }
  return pAnswer;
}
/**
 * Retorna el JSON que contiene los datos del usuario Autenticado en el sistema.
 * @param {*} pParent Es la referencia del elemento que está usando la función
 */
export const OrdenExpressGetCurrentUser = (pParent, ) => {
  var localUser = {};
  try {
    const state = pParent.props.loginReducerState;
    if (state) localUser = state.responseVerifiedUser.result;
  } catch (__) { }
  return localUser;
}
/**
 * Dado el estado en el redux en un evento de llamado AJAX
 * se toma los datos del usuario actual para su procesamiento
 * con la seguridad
 * @param {*} pParent 
 */
export const OrdenExpressGetUserCredentials = (pParent) => {
  var localUser = {};
  try {
    if (pParent) localUser = JSON.stringify(pParent.loginReducerState.responseVerifiedUser.result);
  } catch (__) { }
  return { 'Content-Type': 'application/json', 'credentials': localUser };
}
/**
 * Retorna True si el usuario actualmente autenticado es el administrador
 * @param {*} pParent Es la referencia del elemento que está usando la función
 */
export const OrdenExpressIsAdmin = (pParent) => {
  const state = pParent.props.loginReducerState;
  var result = false;
  try {
    result = state.responseVerifiedUser.result.profile === 'Administrador';
  } catch (__) {
    result = false;
  }
  return result;
}
/**
 * Retorna solo los elementos que coinsiden con la label, esto es para
 * pintar sólo las opciones del menú correspondiente a la label
 * @param {*} routes las rutas del menú
 * @param {*} pLabel la etiqueta con la información a mostrar
 */
export const OrdenExpressGetPathRoutes = (routes, pLabel) => {
  var result = [];
  var pos = 0;
  var length = routes.length;
  while (pos < length) {
    var prop = routes[pos];
    if (prop.collapse) {
      result = result.concat(OrdenExpressGetPathRoutes(prop.views, pLabel));
    } else {
      result.push(prop.layout + prop.path);
    }
    pos++;
  }
  /* routes.map((prop) => {
     if (prop.collapse) {
       result = result.concat(OrdenExpressGetPathRoutes(prop.views, pLabel));
     } else {
       result.push(prop.layout + prop.path);
     }
   });*/
  return result;
}

/**
 * 
 * @param {genera un boton que en el estilo puede tener contenido que lo modifica} pLabel 
 * @param {*} pTextOn 
 * @param {*} ptextOff 
 * @param {*} localData 
 * @param {*} pOnclick 
 * @param {*} pSize 
 * @param {*} pClassName 
 */
export const OrdenExpressButtonSwitchSize = (pLabel, pTextOn, ptextOff, localData, pOnclick, pSize, pClassName = 'btn-icon btn-round mt-2 mb-0 ml-0 pl-0') => {
  return (
    <Button
      className={pClassName}
      color={localData[pLabel] === 0 || localData[pLabel] === undefined ? 'danger' : 'success'}
      type='button'
      outline
      style={pSize}
      onClick={value => {
        pOnclick(pLabel, localData[pLabel] === 0 ? 1 : 0, localData);
      }}
    >
      <i className={localData[pLabel] === 0 || localData[pLabel] === undefined ? 'fa fa-warning' : 'fa fa-check-square-o'} />
    </Button>
  );
}

/**
 * Genera un botón para ser usado como tipo switch
 * @param {*} pLabel 
 * @param {*} pTextOn 
 * @param {*} ptextOff 
 * @param {*} localData 
 * @param {*} pOnclick 
 * @param {*} pClassName 
 */
export const OrdenExpressButtonSwitch = (pLabel, pTextOn, ptextOff, localData, pOnclick, pClassName = 'btn-icon btn-round mt-2 mb-0 ml-0 pl-0') => {
  return (
    <Button
      className={pClassName}
      color={localData[pLabel] === 0 || localData[pLabel] === undefined ? 'danger' : 'success'}
      type='button'
      outline
      size='lg'
      onClick={value => {
        pOnclick(pLabel, localData[pLabel] === 0 ? 1 : 0, localData);
      }}
    >
      <i className={localData[pLabel] === 0 || localData[pLabel] === undefined ? 'fa fa-warning' : 'fa fa-check-square-o'} />
    </Button>
  );
  /*return (
    <Button
      className={pClassName}
      color={localData[pLabel] == 0 || localData[pLabel] == undefined ? 'danger' : 'success'}
      //style={{ width: 180, height: 50 }}
      style={{ width: 80, height: 50 }}
      onClick={() => {
        pOnclick(pLabel, localData[pLabel] === 0 ? 1 : 0, localData);
      }
      }>
      <i className={`nc-icon ${localData[pLabel] == 0 || localData[pLabel] == undefined ? 'nc-simple-remove' : 'nc-check-2'}  text-white`} />
      {localData[pLabel] == 0 || localData[pLabel] == undefined ? ptextOff : pTextOn}
    </Button>
  )*/
}

export const OrdenExpressFragmentRoute = (prop) => {
  var especial1 = Math.floor((Math.random() * 100000) + 1);
  var especial = Date.now();
  return (
    <Route key={especial1 + '-' + especial}
      path={prop.layout + prop.path}
      component={prop.component}
    />
  )
}

export const OrdenExpressGetRoutes = (routes, pLabel, pLastValue = 0) => {
  var result = [];
  var pos = 0;
  var lenghtElements = routes.length;
  while (pos < lenghtElements) {
    var prop = routes[pos];
    if (prop.collapse) {
      result = result.concat(OrdenExpressGetRoutes(prop.views, pLabel, pos));
    }
    if (prop.layout === pLabel) {

      result.push(
        OrdenExpressFragmentRoute(prop)
      );
    }
    pos++;
  }
  return result;
};
/*******************************************************************************************************/

/**
 * Retorna para el sistema los contenidos disponibles en ella
 */
export default this;